document.addEventListener('click', async (e) => {
  const btn = e.target.closest('#LoadMoreBtn');

  if (!btn) return;

  const nextUrl = btn.dataset.nextUrl;

  if (!nextUrl) return;

  btn.disabled = true;
  btn.innerHTML = 'Loading...';

  try {
    const response = await fetch(nextUrl);
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const currentGrid = document.querySelector('#product-grid');
    const newGrid = doc.querySelector('#product-grid');

    if (newGrid) {
      currentGrid.insertAdjacentHTML(
        'beforeend',
        newGrid.innerHTML
      );
    }

    const nextButton = doc.querySelector('#LoadMoreBtn');

    if (nextButton) {
      btn.dataset.nextUrl = nextButton.dataset.nextUrl;
      btn.disabled = false;
      btn.innerHTML = 'Load More';
    } else {
      btn.remove();
    }
  } catch (error) {
    console.error(error);
    btn.disabled = false;
    btn.innerHTML = 'Load More';
  }
});